// @ts-strict-ignore
import {promisifyModal} from 'common/components/modal/utils';
import {MostPopularSeriesData} from 'common/report/queries/app-api/usage-analytics-client-types';
import {getReportUrl} from 'common/report/util';

import {TeammateSidebarJsxProps} from './types';

export async function openTeammateSidebar(attrs: TeammateSidebarJsxProps[`attrs`]) {
  return promisifyModal({
    tagName: `mp-teammate-sidebar`,
    attrs,
    props: {},
    closeEvents: [`submit`],
  });
}

function createReportLink(reportType: string, id: string, projectId: string) {
  let url = ``;
  if (reportType === `Insights Report`) {
    url = `${getReportUrl(`insights`, {projectId})}#report/${id}`;
  } else if (reportType === `Board`) {
    url = `${getReportUrl(`boards`, {projectId})}#id=${id}`;
  } else if (reportType === `Flows Report`) {
    url = `${getReportUrl(`flows`, {projectId})}#report/${id}`;
  } else if (reportType === `Funnels Report`) {
    url = `${getReportUrl(`funnels`, {projectId})}#view/${id}`;
  } else if (reportType === `Retention Report`) {
    url = `${getReportUrl(`retention`, {projectId})}#report/${id}`;
  }
  return url;
}

export function consolidateMostViewedResponse(mostViewedReports, mostViewedDashboards) {
  // We expect the results to have a series key, then a single event inside with all the data
  return [
    ...Object.entries(Object.values(mostViewedReports.series)?.[0] || {}),
    ...Object.entries(Object.values(mostViewedDashboards.series)?.[0] || {}),
  ]
    .sort((a, b) => b[`unique_view_count`] - a[`unique_view_count`])
    .map(([id, entity]: [string, MostPopularSeriesData]) => ({
      name: entity.title,
      link: createReportLink(entity.type, id, entity.project_id),
      type: entity.type.replace(` Report`, ``).toLowerCase(),
      isHidden: !entity.can_view,
    }));
}
